import React from "react";
import {SortIcon} from "./icons";

/**
 * A table header that sorts by `field`. `sort.ordering` is the API's value for
 * the current sort ("name", "-email", ...); the first click on a column sorts
 * ascending, the next one descending. Without `sort` it is a plain header.
 *
 * @param {{
 *   field: string,
 *   sort?: {ordering: string, onChange: (ordering: string) => void},
 *   className?: string,
 *   children: React.ReactNode,
 * }} props
 */
const SortableTh = ({field, sort, className, children}) => {
    if (!sort) return <th className={className}>{children}</th>;

    const direction = sort.ordering === field ? "asc" : sort.ordering === `-${field}` ? "desc" : null;
    return (
        <th
            className={className}
            aria-sort={direction === "asc" ? "ascending" : direction === "desc" ? "descending" : "none"}
        >
            <button
                type="button"
                className="btn btn-link p-0 border-0 fw-bold text-body text-decoration-none d-inline-flex align-items-center gap-1"
                onClick={() => sort.onChange(direction === "asc" ? `-${field}` : field)}
            >
                {children}
                <span className={direction ? undefined : "text-muted"} style={{opacity: direction ? 1 : 0.5}}>
                    <SortIcon direction={direction} />
                </span>
            </button>
        </th>
    );
};

export default SortableTh;
